import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('ButtonGroup', [
  'vertical',
  'small',
]);

const getButtonGroupCss = css`
  display: flex;
  gap: var(--cds-spacing-150);

  &.${classes.vertical} {
    flex-direction: column;
  }

  &.${classes.small} {
    gap: var(--cds-spacing-100);
  }

  ${breakpoints.down('xs')} {
    flex-direction: column;

    & > button,
    & > a {
      width: 100%;
      max-width: none;
    }
  }
`;

export default getButtonGroupCss;
